module.exports = __webpack_public_path__ + "img/logo.bak.9c9301f2.png";